/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import React from 'react'
import TysiaPendingTag from 'DesignSystem/TysiaPendingTag/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/AppointmentAction/MockedBadge/Content"
  
}) {
  return (<React.Fragment
>
<TysiaPendingTag
  viewPath={`${viewPath}/TysiaPendingTag`}
/>
{children}
</React.Fragment>)
}